/*
Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Apache License, Version 2.0 (the "License").
You may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

import React from "react";
import { ServiceMetricProps } from "../../Monitoring";
import { ServiceLogLambdaBufferCommonMetrics } from "../ServiceLogProcessorMetrics";
import MonitorMetrics from "pages/comps/monitor/MonitorMetrics";
import { MetricName, PipelineType } from "API";

const WAFSampledLogProcessorMetric: React.FC<ServiceMetricProps> = (
  props: ServiceMetricProps
) => {
  const { pipelineInfo, startDate, endDate, refreshCount } = props;
  return (
    <MonitorMetrics
      type={PipelineType.SERVICE}
      taskId={pipelineInfo?.id || ""}
      metrics={ServiceLogLambdaBufferCommonMetrics.filter(
        (metric) => metric.title !== MetricName.ExcludedLogs
      )}
      startTime={startDate}
      endTime={endDate}
      refreshCount={refreshCount}
    />
  );
};

export default WAFSampledLogProcessorMetric;
